import {subtractWorkingDays} from './addWorkingDays.ts';
import moment from 'moment/moment';

export function calculateCloseDate(value: string) {
    const date = subtractWorkingDays(moment(value), 10);
    const subtractRequired = Math.abs(1 - date.day());
    return date.subtract(subtractRequired, 'days');
}